<template>
  <div style="margin-top: -80px;">
    <div class="donation-amount-bar" v-if="show_collection">
      <div class="amount-info-box">
        <h2><span>{{ symbol }}</span>{{ formatNumber(needed) }}</h2>
        <span>{{ strings ? strings.target : 'Target Neeeded' }}</span>
      </div>
      <div class="amount-info-box">
        <h2><span>{{ symbol }}</span>{{ formatNumber(collected) }}</h2>
        <span>{{ strings ? strings.collection : 'Collected' }}</span>
      </div>
    </div>
    <div class="donation-box-title">
      <span>{{ tagline }}</span>
      <h2>{{ title }}</h2>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps([
 "strings",
  "show_title",
  "top_title",
  "title",
  "tagline",
  "collected",
  "needed",
  "symbol",
  "show_progress",
  "show_collection",
  "thousand_separator",
  "decimal_separator",
  "number_decimals",
]);

const formatNumber = (value: any) => {
  const n = parseFloat(value);
  if (!isFinite(n)) return value;
  const decimals = Math.max(0, parseInt(String(props.number_decimals), 10) || 0);
  const parts = n.toFixed(decimals).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, props.thousand_separator || '');
  return parts.join(props.decimal_separator || '.');
};

</script>